import "core-js";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./utils/i18n";
import "./utils/rem";
import "./assets/css/base.css";
import store from "@/store";
import { Progress, Loading, Message, Tooltip } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.config.productionTip = false;
Vue.use(Progress);
Vue.use(Tooltip);
Vue.use(Loading.directive); // 使用 Loading 指令

Vue.prototype.$message = Message;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
